import { apiClient } from '../utils/apiClient';

export const specialDayApi = {
    getAll: async (isActive = null) => {
        let url = 'DashboardSpecialDays';
        if (isActive !== null) {
            url += `?isActive=${isActive}`;
        }
        return await apiClient(url);
    },
    getById: async (id) => {
        return await apiClient(`DashboardSpecialDays/${id}`);
    },
    getActiveBanner: async () => {
        return await apiClient('DashboardSpecialDays/active-banner');
    },
    create: async (data) => {
        return await apiClient('DashboardSpecialDays', {
            method: 'POST',
            body: JSON.stringify(data),
        });
    },
    update: async (id, data) => {
        return await apiClient(`DashboardSpecialDays/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
        });
    },
    delete: async (id) => {
        return await apiClient(`DashboardSpecialDays/${id}`, {
            method: 'DELETE',
        });
    },
    toggleActive: async (id, isActive) => {
        return await apiClient(`DashboardSpecialDays/${id}/toggle-active`, {
            method: 'PATCH',
            body: JSON.stringify(isActive),
        });
    }
};

export default specialDayApi;
